import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import Loader from 'ui/Loader/Loader';

import styles from './LoaderPage.module.css';

const LoaderPage = () => {
  const downMdScreen = useMediaQuery(useTheme().breakpoints.down('md'));

  return (
    <div className={styles.container}>
      <Loader size={downMdScreen ? 60 : 80} />
    </div>
  );
};

export default LoaderPage;
